import { Controller } from "@hotwired/stimulus"

// Manages the cancel-trip modal's reason dropdown. When a reason is
// selected, appends ?cancel_reason_id=<id> to the cancel link's href and
// enables the submit button. When Helm has no reasons configured the
// select isn't rendered and the link starts enabled (reason-less cancel).
export default class extends Controller {
  static targets = ["reason", "submit"]
  static values = { baseUrl: String }

  connect() {
    if (this.hasReasonTarget) this.update()
  }

  update() {
    const reasonId = this.reasonTarget.value
    if (reasonId) {
      this.submitTarget.href = `${this.baseUrlValue}?cancel_reason_id=${encodeURIComponent(reasonId)}`
      this.submitTarget.classList.remove("btn-disabled", "pointer-events-none")
    } else {
      this.submitTarget.href = this.baseUrlValue
      this.submitTarget.classList.add("btn-disabled", "pointer-events-none")
    }
  }
}
